









































import DateField from '@/components/FormBuilder/fields/DateField.vue';
import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { UpdatePretensionData } from '@/controllers/types';
import PretensionController from '@/controllers/Pretension';
import { Pretension, PretensionStatus } from '@/types/Pretension';
import UserMixin from '@/mixins/UserMixin';

@Component({
  components: {
    DateField,
  },
})
export default class PretensionSapData extends Mixins(validationMixin, UserMixin) {
  @Prop()
  readonly pretension!: Pretension;

  private sapData = {
    postDate: '',
  };

  private isSavingSapData = false;

  beforeMount() {
    this.fillSapData(this.pretension);
  }

  @Watch('pretension')
  private fillSapData(pretension: Pretension): void {
    Object.assign(this.sapData, {
      postDate: pretension.postDate,
    });
  }

  @Validations()
  validations() {
    return {
      sapData: {
        postDate: {
          required,
        },
      },
    };
  }

  private get isAvailableBlock(): boolean {
    const allowedStatuses = [PretensionStatus.CREATED, PretensionStatus.SIGNER_SIGNING_AWAIT, PretensionStatus.SUPPLIER_SIGNING_AWAIT, PretensionStatus.ACCOUNTING_APPROVE_AWAIT];
    return this.pretension && allowedStatuses.includes(this.pretension.status) && this.isAccountant;
  }

  getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }

  onDateChange(value: string, key: string): void {
    Object.assign(this.sapData, { [key]: value });
  }

  prepareData(): UpdatePretensionData {
    return {
      postDate: this.sapData.postDate,
      pretensionId: Number(this.$route.params?.id),
    };
  }

  async onSubmit(silence = false): Promise<boolean> {
    let answer = false;
    if (!this.isAvailableBlock) {
      this.$bus.$emit('notification', 'Статус претензии не позволяет сохранить данные SAP', 'warning');
      return answer;
    }
    this.$v.$touch();
    if (this.$v.$invalid) return answer;

    try {
      this.isSavingSapData = true;
      const response = await PretensionController.update(this.prepareData());
      const [error, result] = response.result;

      if (result.result) {
        console.log('Result after saving SAP data - ', result);
        if (!silence) this.$bus.$emit('notification', 'Данные SAP успешно сохранены', 'success');
        answer = true;
      }
      if (error) {
        this.$bus.$emit('notification', `Возникла ошибка при сохранении данных SAP, попробуйте позже - ${error}`, 'error');
        console.error(error);
      }
    } catch (error) {
      this.$bus.$emit('notification', `Возникла ошибка при сохранении данных SAP, попробуйте позже - ${error}`, 'error');
      console.error(error);
    } finally {
      this.isSavingSapData = false;
    }
    return answer;
  }
}
